// Formatos de la consola. La plata del gateway va en dólares porque así cobran los proveedores de modelos.
const miles = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

export function usd(v: unknown): string {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  if (n === 0) return 'US$0';
  if (n < 0.01) return `US$${n.toLocaleString('es-CO', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`;
  return `US$${n.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const numero = (v: unknown) => (Number.isFinite(Number(v)) ? miles.format(Number(v)) : '—');

export function momento(ts: string | Date): string {
  return new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'America/Bogota' }).format(new Date(ts));
}

export function desde(ts: string | Date | null | undefined): string {
  if (!ts) return 'Nunca';
  const min = Math.floor((Date.now() - new Date(ts).getTime()) / 60_000);
  if (min < 1) return 'Ahora';
  if (min < 60) return `Hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `Hace ${h} h`;
  const d = Math.floor(h / 24);
  return d === 1 ? 'Ayer' : `Hace ${d} días`;
}

export const diaCorto = (iso: string) => new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(`${iso}T12:00:00Z`));

// Cuándo le toca a un agente o a una rutina por horario.
export const proxima = (ts: string | Date) =>
  new Intl.DateTimeFormat('es-CO', { weekday: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Bogota' }).format(new Date(ts));
